import { ComponentChildren, JSX } from 'preact';
import { ColorPicker } from '@components/color-picker';

/**
 * A styled version of ColorPicker with consistent styling for the admin branding pages
 */
export function StyledColorPicker({
  name,
  color,
  onPick,
  children,
  indicator,
  ...props
}: JSX.LabelHTMLAttributes<HTMLLabelElement> & {
  name: string;
  color?: string;
  onPick(color: string): void;
  children?: ComponentChildren;
  indicator?: ComponentChildren;
}) {
  return (
    <ColorPicker
      name={name}
      color={color}
      onPick={onPick}
      class="p-3 text-left rounded-lg border hover:bg-gray-50"
      indicator={indicator}
      {...props}
    >
      {children}
    </ColorPicker>
  );
}
